module.exports = __webpack_public_path__ + "static/yellowstone-to-yukon-conservation-initiative-logo-cf66754e102d2edc3e0704d2c48559a0.jpg";